import React, { useContext } from 'react';
import Moment from 'react-moment';

import { LocaleContext } from 'context/LocaleContext';

const DateTime = ({ format, children, ...props }) => {
    const locale = useContext(LocaleContext);

    if (Array.isArray(children) && children.length === 1 && typeof children[0] === 'string') {
        children = children[0];

        if (!isNaN(children)) {
            children = Number(children);
        }
    }

    return <Moment format={locale.dateTimeFormats[format] || format} {...props}>{ children }</Moment>;
}

export default DateTime;
